import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84b4c12c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "md:tw-flex tw-justify-between tw-leading-[20px] tw-px-[5px] tw-pb-[20px] tw-pt-[2px]"
}
const _hoisted_2 = { class: "tw-text-[15px] tw-font-semibold tw-text-[#211F58]" }
const _hoisted_3 = {
  key: 0,
  class: "tw-text-[#878787] tw-font-normal tw-text-[13px]"
}
const _hoisted_4 = {
  key: 1,
  class: "tw-flex tw-gap-[6px]"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-global-skeleton tw-h-[30px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[10px] tw-font-[600] tw-rounded-t-[4px]" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-global-skeleton tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[13px] tw-font-[600] tw-rounded-b-[4px]" }, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-global-skeleton tw-h-[30px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[10px] tw-font-[600] tw-rounded-t-[4px]" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-global-skeleton tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[13px] tw-font-[600] tw-rounded-b-[4px]" }, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 3,
  class: "tw-flex tw-gap-[6px]"
}
const _hoisted_13 = { class: "tw-grid tw-items-center tw-gap-y-[6px] tw-flex-1" }
const _hoisted_14 = { class: "tw-h-[30px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[10px] tw-font-[600] tw-rounded-t-[4px] background-item" }
const _hoisted_15 = { class: "tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[13px] tw-font-[600] tw-rounded-b-[4px] background-critical" }
const _hoisted_16 = { class: "tw-grid tw-items-center tw-gap-y-[6px] tw-flex-1" }
const _hoisted_17 = { class: "tw-h-[30px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[10px] tw-font-[600] tw-rounded-t-[4px] background-item" }
const _hoisted_18 = { class: "tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[13px] tw-font-[600] tw-rounded-b-[4px] background-high" }
const _hoisted_19 = { class: "tw-grid tw-items-center tw-gap-y-[6px] tw-flex-1" }
const _hoisted_20 = { class: "tw-h-[30px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[10px] tw-font-[600] tw-rounded-t-[4px] background-item" }
const _hoisted_21 = { class: "tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[13px] tw-font-[600] tw-rounded-b-[4px] background-med" }
const _hoisted_22 = { class: "tw-grid tw-items-center tw-gap-y-[6px] tw-flex-1" }
const _hoisted_23 = { class: "tw-h-[30px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[10px] tw-font-[600] tw-rounded-t-[4px] background-item" }
const _hoisted_24 = { class: "tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[13px] tw-font-[600] tw-rounded-b-[4px] background-low" }

import store from "@/store";
import { getComponentUiText } from "@/utils/utilities";
import { PropType, computed } from "vue";
import { statusScanProgress } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueNumberBlocks',
  props: {
  severity: {
    type: Object as PropType<
      Record<"critical" | "high" | "medium" | "low", number>
    >,
    required: false,
    default: () => ({
      critical: 0,
      high: 0,
      medium: 0,
      low: 0,
    }),
  },
  webServicesId: {
    type: String,
    required: true,
  },
  domainId: {
    type: String,
    required: true,
  },
  displayBorder: {
    type: Boolean,
    required: false,
    default: true,
  },
  data: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const isRefreshing = computed(() => store.state.Scanning.isLoading);
const webserviceScanningId = computed(
  () => store.state.Scanning.webserviceScanningId,
);
const domainScanningId = computed<string>(
  () => store.state.Scanning.domainScanningId,
);

const refreshIssue = async () => {
  store.commit("Scanning/SET_DATA_REFRESH_LOADING", {
    isLoading: true,
    webserviceIds: props.webServicesId,
    domainIds: props.domainId,
  });
  try {
    if (props.webServicesId) {
      await store.dispatch("Scanning/refreshIssuesWebServiceScanning", {
        webserviceIds: props.webServicesId,
      });
    } else {
      await store.dispatch("Scanning/refreshIssuesDomainScanning", {
        domainIds: props.domainId,
      });
    }
  } catch (error) {
    console.log(error);
  } finally {
    store.commit("Scanning/SET_DATA_REFRESH_LOADING", {
      isLoading: false,
      webserviceIds: null,
      domainIds: null,
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${
      __props.displayBorder
        ? 'tw-rounded-[6px] tw-p-[8px] md:tw-p-[20px] tw-bg-[#FFF]'
        : ''
    }`),
    style: _normalizeStyle(__props.displayBorder ? 'border: 1px solid var(--UI-rule, #eff0f1)' : '')
  }, [
    (__props.displayBorder)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(getComponentUiText)("app-scan-scanning-issues-number-block-1")), 1),
          (__props.data.runStatusId !== _unref(statusScanProgress).SCAN_COMPLETE)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-scan-scanning-note-number-block-1")) + " ", 1),
                _createElementVNode("button", {
                  class: "tw-font-medium tw-text-[#387DFF]",
                  style: {"cursor":"pointer"},
                  onClick: refreshIssue
                }, _toDisplayString(_unref(getComponentUiText)("app-scan-scanning-refresh-number-block-1")), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (isRefreshing.value && __props.webServicesId === webserviceScanningId.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
            return _createElementVNode("div", {
              key: index,
              class: "tw-grid tw-items-center tw-gap-y-[6px] tw-flex-1"
            }, _hoisted_7)
          }), 64))
        ]))
      : (isRefreshing.value && __props.domainId === domainScanningId.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
              return _createElementVNode("div", {
                key: index,
                class: "tw-grid tw-items-center tw-gap-y-[6px] tw-flex-1"
              }, _hoisted_11)
            }), 64))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(getComponentUiText)(
              "app-scanning-page-issue-mini-dash-card-critical-1",
            )), 1),
              _createElementVNode("div", _hoisted_15, _toDisplayString(__props.severity.critical), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(getComponentUiText)("app-scanning-page-issue-mini-dash-card-high-1")), 1),
              _createElementVNode("div", _hoisted_18, _toDisplayString(__props.severity.high), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(getComponentUiText)("app-scanning-page-issue-mini-dash-card-med-1")), 1),
              _createElementVNode("div", _hoisted_21, _toDisplayString(__props.severity.medium), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(getComponentUiText)("app-scanning-page-issue-mini-dash-card-low-1")), 1),
              _createElementVNode("div", _hoisted_24, _toDisplayString(__props.severity.low), 1)
            ])
          ]))
  ], 6))
}
}

})